import { fromJS, Map } from 'immutable';
import types from '../constants/userConstant';

const INITIAL_STATE = {
  active_landlord: null,
  active_landlord_error: false,
  landlord_detail: null,
  landlord_detail_loading: false,
  landlord_detail_error: false,
  delegation_detail: null,
  delegation_detail_loading: false,
  delegation_detail_error: false,
  property_update_status: null,
  vp: null,
  rm: null,
  pm: null,
  vp_list_error: false,
  rm_list_error: false,
  pm_list_error: false,
  application: null,
  building: null,
  claim: null,
  policy: null,
  error: null,
  inviteValues: null,
  invite_landlord: null,
  userlist: { data: null, isLoading: false },
  tree_fetch_error: false,
};

const initialImmutableState = fromJS(INITIAL_STATE);

const userReducer = (state = initialImmutableState, action = {}) => {
  switch (action.type) {
    case types.SET_INVITE_LL:
      return state.withMutations((mutableState) => {
        mutableState.set('invite_landlord', fromJS(action.payload));
      });
    case types.SET_ACTIVE_LL:
      return state.withMutations((mutableState) => {
        mutableState.set('active_landlord', fromJS(action.payload));
        mutableState.set('active_landlord_error', false);
      });
    case types.SET_ACTIVE_LANDLORD_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('active_landlord_error', action.payload);
      });
    case types.GET_LANDLORD_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set('landlord_detail_loading', true);
        mutableState.set('landlord_detail_error', false);
      });
    case types.SET_LANDLORD_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set('landlord_detail', fromJS(action.payload));
        mutableState.set('landlord_detail_loading', false);
        mutableState.set('landlord_detail_error', false);
      });
    case types.SET_LANDLORD_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('landlord_detail_loading', false);
        mutableState.set('landlord_detail_error', true);
      });
    case types.GET_DELEGATION_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set('delegation_detail_loading', true);
        mutableState.set('delegation_detail_error', false);
      });
    case types.SET_DELEGATION_DETAIL:
      return state.withMutations((mutableState) => {
        mutableState.set('delegation_detail', fromJS(action.payload));
        mutableState.set('delegation_detail_loading', false);
        mutableState.set('delegation_detail_error', false);
      });
    case types.SET_DELEGATION_DETAIL_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('delegation_detail_loading', false);
        mutableState.set('delegation_detail_error', true);
      });
    case types.UPDATE_USER_PROPERTY:
      return state.withMutations((mutableState) => {
        mutableState.set('property_update_status', 'pending');
      });
    case types.UPDATE_USER_PROPERTY_SUCCESS:
      return state.withMutations((mutableState) => {
        mutableState.set('property_update_status', 'success');
      });
    case types.UPDATE_USER_PROPERTY_FAILURE:
      return state.withMutations((mutableState) => {
        mutableState.set('property_update_status', 'failure');
      });
    case types.SET_VP:
      return state.withMutations((mutableState) => {
        mutableState.set('vp', fromJS(action.payload));
        mutableState.set('vp_list_error', false);
      });
    case types.SET_RM:
      return state.withMutations((mutableState) => {
        mutableState.set('rm', fromJS(action.payload));
        mutableState.set('rm_list_error', false);
      });
    case types.SET_PM:
      return state.withMutations((mutableState) => {
        mutableState.set('pm', fromJS(action.payload));
        mutableState.set('pm_list_error', false);
      });
    case types.SET_VP_LIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('vp_list_error', action.payload);
      });
    case types.SET_RM_LIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('rm_list_error', action.payload);
      });
    case types.SET_PM_LIST_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('pm_list_error', action.payload);
      });
    case types.SET_LANDLORDTREE:
      return state.withMutations((mutableState) => {
        mutableState.set('landlord_tree', fromJS(action.payload));
        mutableState.set('tree_fetch_error', false);
      });
    case types.SET_VPTREE:
      return state.withMutations((mutableState) => {
        mutableState.set('vp_tree', fromJS(action.payload));
        mutableState.set('tree_fetch_error', false);
      });
    case types.SET_RMTREE:
      return state.withMutations((mutableState) => {
        mutableState.set('rm_tree', fromJS(action.payload));
        mutableState.set('tree_fetch_error', false);
      });
    case types.SET_TREE_FETCH_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('tree_fetch_error', action.payload);
      });
    case types.SET_USER_BUILDING_SEARCH:
      return state.withMutations((mutableState) => {
        mutableState.set('user_building_search', fromJS(action.payload));
      });
    case types.SET_ERR:
      return state.withMutations((mutableState) => {
        mutableState.set('error', fromJS(action.payload));
      });
    case types.SET_TREE_LOADING:
      return state.withMutations((mutableState) => {
        mutableState.set('treeloading', fromJS(action.payload));
      });
    case types.GET_USER_LIST:
      return state.withMutations((mutableState) => {
        mutableState.updateIn(['userlist'], (mutableState = Map()) =>
          mutableState.set('isLoading', true),
        );
      });
    case types.SET_USER_LIST:
      return state.withMutations((mutableState) => {
        mutableState.set('userlist', fromJS({ ...action.payload, isLoading: false }));
      });
    default:
      return state;
  }
};

export default userReducer;
